import dayjs from "dayjs";
import { ListItemBadge } from "@components/ListItemCardCst/types";
import { EnrolledUserItem } from "../types";
import {
  NO_EXPIRATION_SENTINEL,
  formatEnrollmentDate,
} from "./enrollmentDates";
import { resolveEnrollmentStatusKey } from "./enrollmentStatus";

const STATUS_KEYS_WITH_BADGE = [
  "to-start",
  "in-progress",
  "top-down-needed",
  "failed",
];

export interface ExpirationBadgeInfo {
  variant: ListItemBadge["variant"];
  date: string;
  isExpired: boolean;
}

export const hasEnrollmentExpiration = (
  expirationDate?: string | null,
): boolean =>
  !!expirationDate &&
  !String(expirationDate).startsWith(NO_EXPIRATION_SENTINEL);

export const isEnrollmentExpired = (expirationDate?: string | null): boolean =>
  hasEnrollmentExpiration(expirationDate) &&
  dayjs(expirationDate).isBefore(dayjs(), "day");

export const resolveExpirationBadge = (
  user: EnrolledUserItem,
): ExpirationBadgeInfo | null => {
  if (!hasEnrollmentExpiration(user.expirationDate)) return null;
  if (!STATUS_KEYS_WITH_BADGE.includes(resolveEnrollmentStatusKey(user)))
    return null;
  const isExpired = isEnrollmentExpired(user.expirationDate);
  return {
    variant: user.isExpirationHard || isExpired ? "error" : "warning",
    date: formatEnrollmentDate(user.expirationDate),
    isExpired,
  };
};
